import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import HasPermission from "../../../components/HasPermission";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";
import Header from "components/Headers/Header";
import { animeList, updateAnimeStatus, getAnimeById } from "utils/endpoint";
import Select from "react-select";
import { Input } from "reactstrap";
import { toast } from "react-toastify";
import UseFullPageLoader from "utils/UseFullPageLoader";
import useSearchParams from "utils/useSearchParams";
import { randomIndex, get_publisher_list, get_status_list } from "utils/Commen";
import { colors } from "utils/enums";

function AnimeList(args) {
  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = UseFullPageLoader();
  const [params] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [animeLists, setAnimeLists] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [sort_key, setSortKey] = useState("created_at");
  const [sort_by, setSortBy] = useState("DESC");
  const [filterStudio, setFilterStudio] = useState("");
  const [filterRelFromDate, setFilterRelFromDate] = useState("");
  const [filterRelToDate, setFilterRelToDate] = useState("");
  const [filterPublisher, setFilterPublisher] = useState([]);
  const [filterStatus, setFilterStatus] = useState([]);
  const [publisherList, setPublisherList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [publisherSelected, setPublisherSelected] = useState(null);
  const [statusSelected, setStatusSelected] = useState(null);


  const getUrl = (baseUrl) => {
    return baseUrl;
  };

  const sortColumns = (currentSortKey, currentSortBy) => {
    let mySortKey = currentSortKey;
    let mySortBy = currentSortBy === "ASC" ? "DESC" : "ASC";
    setSortKey(mySortKey);
    setSortBy(mySortBy);
    getAnimeList({ sort_key: mySortKey, sort_by: mySortBy, studio: filterStudio, rel_from_date: filterRelFromDate, rel_to_date: filterRelToDate, publisher_id: filterPublisher, status_id: filterStatus });
  };

  const getAnimeList = async (filter) => {
    setIsLoading(true);
    showLoader();
    try {
      const result = await animeList(filter);
      if (result?.isSuccess) {
        setAnimeLists(result?.data?.data?.records);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  };

  const handleStatus = async (data) => {
    const res = await updateAnimeStatus(data);
    if (res.isSuccess) {
      toast.success(res.message);
      getAnimeList({ sort_key, sort_by });
    }
  };

  const getPublisherList = async () => {
    const allPublisher = await get_publisher_list();
    const jpPublisherList = allPublisher.filter((publisher) => publisher.publisher_type == "JP");
    setPublisherList([{ id: "8f97245b-5d1a-4dfd-8158-7211baf22e82", name: "None" }, ...jpPublisherList]);
  };

  const getStatusList = async () => {
    const allStatus = await get_status_list();
    setStatusList([{ id: "8f97245b-5d1a-4dfd-8158-7211baf22e82", name: "None" }, ...allStatus]);
  };

  const searchData = async () => {
    getAnimeList({ sort_key, sort_by, studio: filterStudio, rel_from_date: filterRelFromDate, rel_to_date: filterRelToDate, publisher_id: filterPublisher, status_id: filterStatus });
  };

  const removeSearch = () => {
    setFilterStudio("");
    setFilterRelFromDate("");
    setFilterRelToDate("");
    setFilterPublisher([]);
    setFilterStatus([]);
    setPublisherSelected(null);
    setStatusSelected(null);
    getAnimeList({ sort_key, sort_by });
  };

  useEffect(() => {
    getAnimeList({ sort_key, sort_by });
    getPublisherList();
    getStatusList();
    const loginData = JSON.parse(localStorage.getItem("User"));
    if (loginData) {
      setPermissions(loginData.permissions);
    }
  }, []);

  const formatRelDate = (date, precision) => {
    if (!date) return "";
    const d = moment(date);
    switch (precision) {
      case "MONTH_YEAR":
        return d.format("MMM YYYY");
      case "QUARTER_YEAR":
        const quarter = Math.floor(d.month() / 3) + 1;
        return `Q${quarter} ${d.year()}`;
      case "YEAR_ONLY":
        return d.format("YYYY");
      case "EXACT":
      default:
        return d.format("YYYY-MM-DD");
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col lg="6">
                    <h1 className="mb-0">Anime List</h1>
                  </Col>
                  <Col lg="6" className="text-right">
                    <HasPermission slug="create-anime">
                      <Button
                        color="primary"
                        onClick={() => navigate("/admin/anime/create-anime")}
                      >
                        Add Anime
                      </Button>
                      <Button
                        color="primary"
                        onClick={() => navigate("/admin/anime/import-anime")}
                        className="ml-2"
                      >
                        Import Anime
                      </Button>
                    </HasPermission>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row className="mb-3">
                  <Col lg="2">
                    <Select
                      name="publisher_id"
                      id="publisher_id"
                      className="react-select mt-1"
                      placeholder="Publisher"
                      classNamePrefix="my-react-select"
                      isMulti
                      value={publisherSelected}
                      options={publisherList.map((value) => ({ value: value.id, label: value.name }))}
                      onChange={(event) => {
                        setFilterPublisher(event.map((x) => x.value));
                        setPublisherSelected(event);
                      }}
                    />
                  </Col>
                  <Col lg="2">
                    <Select
                      name="status_id"
                      id="status_id"
                      className="react-select mt-1"
                      placeholder="Status"
                      classNamePrefix="my-react-select"
                      isMulti
                      value={statusSelected}
                      options={statusList.map((value) => ({ value: value.id, label: value.name }))}
                      onChange={(event) => {
                        setFilterStatus(event.map((x) => x.value));
                        setStatusSelected(event);
                      }}
                    />
                  </Col>
                  <Col lg="2">
                    <Input
                      className="form-control mt-1"
                      id="studio"
                      name="studio"
                      placeholder="Studio"
                      type="text"
                      value={filterStudio}
                      onChange={(e) => setFilterStudio(e.target.value)}
                    />
                  </Col>
                  <Col lg="2">
                    <Input
                      className="form-control mt-1"
                      id="rel_from_date"
                      name="rel_from_date"
                      type="date"
                      value={filterRelFromDate}
                      onChange={(e) => setFilterRelFromDate(e.target.value)}
                    />
                  </Col>
                  <Col lg="2">
                    <Input
                      className="form-control mt-1"
                      id="rel_to_date"
                      name="rel_to_date"
                      type="date"
                      value={filterRelToDate}
                      onChange={(e) => setFilterRelToDate(e.target.value)}
                    />
                  </Col>
                  <Col lg="2" className="mt-1 d-flex flex-row mt-1">
                    <Button color="primary" onClick={searchData} style={{ flex: 1 }}>
                      Search
                    </Button>
                    <Button color="danger" onClick={removeSearch} className="ml-2">
                      <i className="fa fa-times" />
                    </Button>
                  </Col>
                </Row>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th>No.</th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => sortColumns("en_title", sort_by)}
                      >
                        EN Title
                        {sort_key === "en_title" && (
                          <i className={`fa fa-arrow-${sort_by === "ASC" ? "up" : "down"} ml-1`} />
                        )}
                      </th>
                      <th>JP Publisher</th>
                      <th>Studio</th>
                      <th>Studio Link</th>
                      <th>Epis.</th>
                      <th>VoD in France</th>
                      <th>Ratings</th>
                      <th>Link VoD</th>
                      <th>Rel. Date</th>
                      <th>EN Dub</th>
                      <th>FR Dub</th>
                      <th>Comments</th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => sortColumns("created_at", sort_by)}
                      >
                        CreatedAt
                        {sort_key === "created_at" && (
                          <i className={`fa fa-arrow-${sort_by === "ASC" ? "up" : "down"} ml-1`} />
                        )}
                      </th>
                      <HasPermission slug="view-anime-product-pl">
                        <th>Product P&L</th>
                      </HasPermission>
                      <HasPermission slug="update-anime">
                        <th>Is Active</th>
                        <th className="action">Action</th>
                      </HasPermission>
                    </tr>
                  </thead>
                  <tbody>
                    {animeLists.map((info, index) => (
                      <tr key={info.id}>
                        <td>{index + 1}</td>
                        <td className="word_wrap">
                          <span
                            className="primary-text-color"
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate(`/admin/anime/view-anime/${info.id}`, { state: { row: info } })}
                          >
                            {info.en_title}
                          </span>
                        </td>
                        <td>{info.licensor}</td>
                        <td className="word_wrap">{info.studio}</td>
                        <td className="link primary-text-color">
                          <a href={info.studio_link} target="_blank" rel="noreferrer">
                            {info.studio_link}
                          </a>
                        </td>
                        <td>{info.no_of_episodes}</td>
                        <td className="word_wrap">{info.platforms}</td>
                        <td>{info.ratings}</td>
                        <td className="link primary-text-color">
                          <a href={info.vod_link} target="_blank" rel="noreferrer">
                            {info.vod_link}
                          </a>
                        </td>
                        <td>{formatRelDate(info.rel_date, info.rel_date_precision)}</td>
                        <td>{info.en_dub}</td>
                        <td>{info.fr_dub}</td>
                        <td className="word_wrap">{info.comment}</td>
                        <td>{moment(info.created_at).format("YYYY-MM-DD HH:mm:ss")}</td>
                        <HasPermission slug="view-anime-product-pl">
                          <td className="link primary-text-color">
                            <a href={info.product_pl} target="_blank" rel="noreferrer">
                              {info.product_pl}
                            </a>
                          </td>
                        </HasPermission>
                        <HasPermission slug="update-anime">
                          <td>
                            <label className="custom-toggle">
                              <input
                                type="checkbox"
                                checked={info.is_active}
                                onChange={() => handleStatus({ id: info.id, is_active: !info.is_active })}
                              />
                              <span className="custom-toggle-slider rounded-circle" />
                            </label>
                          </td>
                          <td className="action">
                            <Button
                              color="primary"
                              size="sm"
                              onClick={async () => {
                                const res = await getAnimeById({ anime_id: info.id });
                                navigate(`/admin/anime/update-anime/${info.id}`, { state: { row: res?.data } });
                              }}
                            >
                              Edit
                            </Button>
                          </td>
                        </HasPermission>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default AnimeList;
